import { MutationTree } from 'vuex';
import { EUpdateDirectoryMutation } from './update-directory.constants';
import { IUpdateDirectoryState } from './update-directory.types';
import { IDirectory } from '@/api/directories/types/directory';

export const mutations: MutationTree<IUpdateDirectoryState> = {
  [EUpdateDirectoryMutation.SetUpdating](state: IUpdateDirectoryState, updating: boolean) {
    state.updating = updating;
  },
  [EUpdateDirectoryMutation.SetUpdatedDirectory](
    state: IUpdateDirectoryState,
    directory: IDirectory
  ) {
    state.updatedDirectory = directory;
  },
  [EUpdateDirectoryMutation.SetState](
    state: IUpdateDirectoryState,
    newState: IUpdateDirectoryState
  ) {
    state.updatedDirectory = newState.updatedDirectory;
    state.updating = newState.updating;
  },
};
